import { Link } from "react-router-dom";
import { Logo } from "@/lib/brand";
import { useCompany, copyrightLine } from "@/lib/company";
import { CardLogos } from "@/components/PaymentLogos";
import { InstagramLogo, EnvelopeSimple, MapPin, LockKey } from "@phosphor-icons/react";

const LINKS = [
  ["/#planos", "Planos e preços", "a"], ["/register", "Criar conta"], ["/login", "Entrar"],
  ["/termos", "Termos de utilização"], ["/privacidade", "Política de privacidade"], ["/politica-de-devolucao", "Política de devolução"],
];

function FooterLink({ to, label, raw }) {
  const cls = "text-white/75 transition-colors hover:text-mint";
  return raw ? <a href={to} className={cls}>{label}</a> : <Link to={to} className={cls}>{label}</Link>;
}

export function SiteFooter() {
  const c = useCompany();
  return (
    <footer className="bg-petrol text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 py-14 md:grid-cols-[1.3fr_1fr_1fr]">
        <div className="space-y-4">
          <Link to="/" aria-label="GestaCV — início"><Logo onDark className="h-9 w-auto" testid="footer-logo" /></Link>
          <p className="max-w-sm text-white/75">Gestão para pequenas e médias empresas, feita em Cabo Verde, para Cabo Verde.</p>
          <a href="https://www.instagram.com/gestacv" target="_blank" rel="noreferrer" aria-label="Instagram GestaCV" data-testid="footer-instagram-link"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-mint text-mint-ink transition-transform hover:-translate-y-0.5">
            <InstagramLogo size={22} weight="bold" />
          </a>
        </div>
        <nav className="grid content-start gap-2.5 text-sm" data-testid="footer-links">
          {LINKS.map(([to, label, raw]) => <FooterLink key={to} to={to} label={label} raw={raw} />)}
        </nav>
        <div className="space-y-3 text-sm text-white/75" data-testid="footer-contact">
          {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 hover:text-mint"><EnvelopeSimple size={17} className="text-mint" />{c.email}</a>}
          <div className="flex items-center gap-2"><MapPin size={17} className="text-mint" />{c.address ? `${c.address}, Cabo Verde` : "Cabo Verde"}</div>
        </div>
      </div>
      <div className="mx-auto max-w-6xl border-t border-white/10 px-6 py-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/50">Cartões aceites</span>
            <CardLogos className="h-5" />
          </div>
          <div className="flex items-center gap-1.5 text-xs text-white/60"><LockKey size={14} className="text-mint" /> Ligação segura HTTPS · autenticação 3-D Secure</div>
        </div>
        <div className="mt-4 flex flex-wrap items-end justify-between gap-3 text-xs text-white/60">
          <p data-testid="footer-copyright">{c.legal_name ? copyrightLine(c) : ""}</p>
          <p>Feito com cuidado em Cabo Verde</p>
        </div>
      </div>
    </footer>
  );
}
